import { useEffect, useRef, useState } from "react"
import { fetchQuery, graphql } from 'relay-runtime'
import Env from '@src/RelayEnvironment'
import type { Game } from '@src/components/Game/Game.types'
import { isUserLoggedIn } from "@src/utils/functions"
import { ThumbnailSliderRecommendationsQuery } from "./__generated__/ThumbnailSliderRecommendationsQuery.graphql"

export const useUserRecommendations = (shouldFetch: boolean) => {
  const [games, setGames] = useState<Game[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const isLoggedIn = isUserLoggedIn()
  const hasFetchedRef = useRef(false)


  useEffect(() => {
    if (!shouldFetch || hasFetchedRef.current || !isLoggedIn) {
      setIsLoading(false)
      return
    }

    setIsLoading(true)

    fetchQuery<ThumbnailSliderRecommendationsQuery>(
      Env,
      userRecommendationsQuery,
      {},
      { fetchPolicy: 'network-only' }
    ).subscribe({
      next: (data) => {
        setGames([...data.userRecommendations])
        setIsLoading(false)
        hasFetchedRef.current = true
      },
      error: (err) => {
        console.error('Error fetching recommendations:', err)
        setIsLoading(false)
      },
      complete: () => {
        setIsLoading(false)
      },
    })
  }, [shouldFetch, isLoggedIn])

  return { games, isLoading }
}

const userRecommendationsQuery = graphql`
  query ThumbnailSliderRecommendationsQuery {
    userRecommendations {
      urlThumb
      aggregator
      gameId
      category
      provider
      label
      customThumb
    }
  }
`
